<script>
import { uploadSiteInspectionDocuments } from '@/utils/site-inspection'

export default {

    inject: ['setLoading'],

    data() {
        return {
            id: null,
            inspection_number: '',
            documents: [
                { name: '', file: null }
            ],
            errors: {}
        }
    },

    methods: {

        cleanError(msg) {
            if (!msg) return ''
            return msg
                .replace(/The documents\.\d+\.document/, 'Document file')
                .replace(/The documents\.\d+\.name/, 'Document name')
                .replace(' field is required.', ' is required.')
        },

        open(row) {
            this.reset()
            this.$nextTick(() => {
                this.id = row.id
                this.inspection_number = row.inspection_number
            })
        },

        addRow() {
            this.documents.push({ name: '', file: null })
        },

        removeRow(index) {
            if (this.documents.length > 1) {
                this.documents.splice(index, 1)
            }
        },

        handleFile(index, event) {
            const file = event.target.files[0]
            if (file) {
                this.documents[index].file = file
                if (!this.documents[index].name) {
                    this.documents[index].name = file.name.replace(/\.[^/.]+$/, '')
                }
            } else {
                this.documents[index].file = null
            }
        },

        async save() {
            this.setLoading(true)
            this.errors = {}

            try {
                const formData = new FormData()

                this.documents.forEach((doc, i) => {
                    formData.append(`documents[${i}][name]`, doc.name || '')
                    if (doc.file) {
                        formData.append(`documents[${i}][document]`, doc.file)
                    }
                })

                const res = await uploadSiteInspectionDocuments(this.id, formData)

                this.$swalToast(res.data.message)
                this.$emit('updated')
                this.$closeModal('upload_inspection_doc_modal')

            } catch (error) {
                if (error.type === 'validation') {
                    this.errors = error.errors
                } else {
                    this.$swalToast(error.message, 'error')
                }
            } finally {
                this.setLoading(false)
            }
        },

        getError(index, field) {
            const key = `documents.${index}.${field}`
            return this.errors[key] ? this.errors[key][0] : null
        },

        reset() {
            this.id = null
            this.inspection_number = ''
            this.documents = [{ name: '', file: null }]
            this.errors = {}

            // Clear all file inputs
            this.$nextTick(() => {
                const fileInputs = this.$el?.querySelectorAll('input[type="file"]')
                if (fileInputs) {
                    fileInputs.forEach(input => input.value = '')
                }
            })
        },
    }
}
</script>

<template>
    <div class="modal fade" id="upload_inspection_doc_modal">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">

                <div class="modal-header">
                    <h5>Upload Documents</h5>
                    <button class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <form @submit.prevent="save">
                    <div class="modal-body">

                        <!-- Inspection Number (read-only) -->
                        <div class="mb-3">
                            <label class="form-label">Inspection #</label>
                            <input type="text" class="form-control" :value="inspection_number" disabled />
                        </div>

                        <!-- Document Rows -->
                        <div v-for="(doc, index) in documents" :key="index"
                            class="d-flex align-items-start gap-2 mb-3">

                            <!-- Document Name -->
                            <div class="flex-grow-1">
                                <label class="form-label" v-if="index === 0">Document Name</label>
                                <input type="text" class="form-control" v-model="doc.name"
                                    placeholder="Enter document name" />
                                    <!-- Document Name Error -->
                                <div v-if="getError(index, 'name')"
                                    style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                                    <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ cleanError(getError(index, 'name')) }}
                                </div>
                            </div>

                            <!-- Document File -->
                            <div class="flex-grow-1">
                                <label class="form-label" v-if="index === 0">Document File <span style="color:#f43f5e;">*</span></label>
                                <input type="file" class="form-control" @change="handleFile(index, $event)" />
                                <!-- Document File Error -->
                                <div v-if="getError(index, 'document')"
                                    style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                                    <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ cleanError(getError(index, 'document')) }}
                                </div>
                            </div>

                            <!-- Remove Row -->
                            <!-- <div :style="{ marginTop: index === 0 ? '28px' : '0' }">
                                <button type="button" class="btn btn-sm btn-outline-danger" @click="removeRow(index)"
                                    :disabled="documents.length === 1">
                                    <i class="ti ti-trash"></i>
                                </button>
                            </div> -->

                        </div>

                        <!-- Add More -->
                        <!-- <button type="button" class="btn btn-sm btn-outline-primary" @click="addRow">
                            <i class="ti ti-plus me-1"></i> Add More
                        </button> -->

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary">
                            <i class="ti ti-upload me-1"></i> Upload
                        </button>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>